import axios from 'axios'
const target = process.env.NODE_ENV === 'development' ? '/api' : '/Recruit/PostHandler.ashx'

export function getRegionList(data) {
  return axios.post(target, { funcode: 'getRegionList', ...data })
}

export function getStoreList() {
  return axios.post(target, { funcode: 'getStoreList' })
}

export function getRecruitPostList(data) {
  return axios.post(target, { funcode: 'getRecruitPostList', ...data })
}

export function getSwipe() {
  return axios.post(target, { funcode: 'getSwipe' })
}

export function getDictData() {
  return axios.post(target, { funcode: 'getDictData' })
}

export function getResume(data) {
  return axios.post(target, { funcode: 'getResume', ...data })
}

export function getTestSurvey(data) {
  return axios.post(target, { funcode: 'getTestSurvey', ...data })
}

export function changeDepart(data) {
  return axios.post(target, { funcode: 'changeDepart', ...data })
}

export function changePost(data) {
  return axios.post(target, { funcode: 'changePost', ...data })
}

export function oauth(data) {
  return axios.post(target, { funcode: 'oauth', ...data })
}

export function postResume(data) {
  return axios.post(target, { funcode: 'postResume', ...data })
}

export function editResume(data) {
  return axios.post(target, { funcode: 'editResume', ...data })
}

export function addWorkHis(data) {
  return axios.post(target, { funcode: 'addWorkHis', ...data })
}

export function editWorkHis(data) {
  return axios.post(target, { funcode: 'editWorkHis', ...data })
}

export function deleteWorkHis(data) {
  return axios.post(target, { funcode: 'deleteWorkHis', ...data })
}

export function addFamilyContact(data) {
  return axios.post(target, { funcode: 'addFamilyContact', ...data })
}

export function editFamilyContact(data) {
  return axios.post(target, { funcode: 'editFamilyContact', ...data })
}

export function deleteFamilyContact(data) {
  return axios.post(target, { funcode: 'deleteFamilyContact', ...data })
}

export function uploadPhoto(formData) {
  return axios({
    method: 'post',
    // 服务器上传地址
    url: target,
    data: formData,
    headers: {
      // 修改请求头
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function uploadFile(formData) {
  return axios({
    method: 'post',
    // 服务器上传地址
    url: target,
    data: formData
  })
}
